import produce from 'immer';

// TYPES
import { Types, ConsultaFazendaSefazCep } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: ConsultaFazendaSefazCep = {
	status: 0,
	data: null,
};

export default function consultaFazendaSefazCepReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaFazendaSefazCep {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_FAZENDA_CPF_CEP_SEFAZ: {
				break;
			}

			case Types.CONSULTA_FAZENDA_CPF_CEP_SEFAZ_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTA_FAZENDA_CPF_CEP_SEFAZ_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			default:
		}
	});
}
